/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_UploadedInputs */

const en_common_uploaded = /** @type {(inputs: Common_UploadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uploaded`)
};

const es_common_uploaded = /** @type {(inputs: Common_UploadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subido`)
};

/**
* | output |
* | --- |
* | "Uploaded" |
*
* @param {Common_UploadedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_uploaded = /** @type {((inputs?: Common_UploadedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_UploadedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_uploaded(inputs)
	return en_common_uploaded(inputs)
});